/* Pappy Retro — tabs, rails, reveals, quick add + quick view.
   Adds to the REAL Shopify cart via /cart/add.js, then asks Impulse to rebuild and open its cart drawer. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = function (cents) {
    try { return (window.theme && theme.Currency && theme.settings) ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : '$' + (cents / 100).toFixed(2); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- cart ---------- */
  function add(id, qty, img, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (img) fly(img);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('pappy:cart:add', { detail: { id: +id, quantity: qty || 1 } }));
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = btn.dataset.label; btn.disabled = false; }, 1400); }
        return j;
      })
      .catch(function (e) {
        if (btn) { btn.textContent = (e && e.description) || 'Try again'; setTimeout(function () { btn.textContent = btn.dataset.label; btn.disabled = false; }, 2200); }
      });
  }
  function fly(img) {
    var cart = $('.js-drawer-open-cart'); if (reduce || !cart || !img) return;
    var a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    var f = img.cloneNode(); f.removeAttribute('srcset'); f.className = 'pr-fly';
    f.style.left = (a.left + a.width / 2 - 35) + 'px'; f.style.top = (a.top + a.height / 2 - 35) + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () {
      f.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.25)';
      f.style.opacity = '.4';
    });
    setTimeout(function () { f.remove(); }, 720);
  }

  /* ---------- quick view (multi-variant products) ---------- */
  var qv;
  function ensureQV() {
    if (qv) return qv;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="pr-scope pr-section pr-qv" role="dialog" aria-modal="true" aria-label="Choose options"><div class="pr-bg" data-pr-close></div>' +
      '<div class="pr-box"><button class="pr-x" data-pr-close aria-label="Close">✕</button><img alt=""><div class="pr-info"></div></div></div>');
    qv = $('.pr-qv');
    return qv;
  }
  function closeQV() { if (qv) qv.classList.remove('pr-on'); }
  function quickView(handle, srcImg) {
    var q = ensureQV();
    fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var img = $('img', q); img.src = (p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (p.featured_image && p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=700'; img.alt = p.title;
      var opts = p.options.filter(function (o) { return o.name !== 'Title'; });
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var sel = first.options.slice();
      $('.pr-info', q).innerHTML = '<h3>' + p.title + '</h3><div class="pr-price" style="margin:8px 0">' + money(first.price) + '</div>' +
        opts.map(function (o, i) {
          return '<div class="pr-opt"><label>' + o.name + ': <span data-lab="' + i + '">' + sel[i] + '</span></label><div class="pr-chips">' +
            o.values.map(function (v) { return '<button type="button" class="pr-chip" data-i="' + i + '" data-v="' + v.replace(/"/g, '&quot;') + '">' + v + '</button>'; }).join('') + '</div></div>';
        }).join('') +
        '<button type="button" class="pr-btn pr-block pr-qv-add">Add to Cart</button>' +
        '<p style="text-align:center;margin-top:12px"><a class="pr-link" href="' + p.url + '">View full details</a></p>';
      var cur;
      function update() {
        cur = p.variants.filter(function (v) { return v.options.join('|') === sel.join('|'); })[0];
        $$('.pr-chip', q).forEach(function (c) {
          c.setAttribute('aria-pressed', sel[c.dataset.i] === c.dataset.v);
          var test = sel.slice(); test[c.dataset.i] = c.dataset.v;
          var v = p.variants.filter(function (v) { return v.options.join('|') === test.join('|'); })[0];
          c.classList.toggle('pr-na', !v || !v.available);
        });
        sel.forEach(function (s, i) { var l = $('[data-lab="' + i + '"]', q); if (l) l.textContent = s; });
        var b = $('.pr-qv-add', q), ok = cur && cur.available;
        b.disabled = !ok; b.textContent = !cur ? 'Unavailable' : ok ? 'Add to Cart — ' + money(cur.price) : 'Sold Out';
        $('.pr-price', q).textContent = money(cur ? cur.price : first.price);
      }
      $('.pr-info', q).onclick = function (e) {
        var c = e.target.closest('.pr-chip'); if (c) { sel[c.dataset.i] = c.dataset.v; update(); }
        if (e.target.closest('.pr-qv-add') && cur) { closeQV(); add(cur.id, 1, srcImg); }
      };
      update(); q.classList.add('pr-on'); var x = $('.pr-x', q); x && x.focus();
    });
  }

  /* ---------- tabs + rails ---------- */
  function initHangar(sec) {
    var tabs = $$('.pr-tab', sec), panels = $$('.pr-panel', sec);
    function show(key) {
      var hit = false;
      tabs.forEach(function (t) { var on = t.dataset.key === key; t.setAttribute('aria-selected', on); if (on) hit = true; });
      if (!hit) return false;
      panels.forEach(function (p) { p.hidden = p.dataset.key !== key; if (!p.hidden) { var r = $('.pr-rail', p); r.scrollLeft = 0; arrows(p); } });
      return true;
    }
    function arrows(p) {
      var r = $('.pr-rail', p), l = $('.pr-arrow.pr-l', p), rr = $('.pr-arrow.pr-r', p); if (!r || !l) return;
      l.disabled = r.scrollLeft < 8; rr.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
    }
    sec.addEventListener('click', function (e) {
      var t = e.target.closest('.pr-tab'); if (t) show(t.dataset.key);
      var a = e.target.closest('.pr-arrow'); if (a) { var r = $('.pr-rail', a.closest('.pr-panel')); r.scrollBy({ left: (a.classList.contains('pr-l') ? -1 : 1) * r.clientWidth * .9, behavior: 'smooth' }); }
    });
    panels.forEach(function (p) { var r = $('.pr-rail', p); r && r.addEventListener('scroll', function () { arrows(p); }, { passive: true }); arrows(p); });
    sec._prShow = show;
  }
  window.pappyShowTab = function (key) {
    var ok = false; $$('[data-pr-hangar]').forEach(function (s) { if (s._prShow && s._prShow(key)) ok = true; }); return ok;
  };

  /* ---------- reveals ---------- */
  function reveals(scope) {
    var els = $$('.pr-rv:not(.pr-in)', scope);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('pr-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('pr-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('pr-in'); }); }, 4000); // safety net
  }

  function init(scope) {
    $$('[data-pr-hangar]', scope).forEach(function (s) { if (!s._prShow) initHangar(s); });
    reveals(scope);
    var m = location.search.match(/[?&]tab=([\w-]+)/); if (m) window.pappyShowTab(m[1]);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pr-add]');
    if (a) { e.preventDefault(); var im = a.closest('.pr-card,.pr-deal') && $('img', a.closest('.pr-card,.pr-deal')); add(a.dataset.prAdd, 1, im, a); return; }
    var q = e.target.closest('[data-pr-qv]');
    if (q) { e.preventDefault(); quickView(q.dataset.prQv, q.closest('.pr-card') && $('img', q.closest('.pr-card'))); return; }
    if (e.target.closest('[data-pr-close]')) { closeQV(); return; }
    var t = e.target.closest('[data-pr-tab]');
    if (t && t.dataset.prTab) { if (window.pappyShowTab(t.dataset.prTab)) { /* let anchor scroll */ } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.pr-club form'); if (f) { /* native customer form post; nothing to intercept */ }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var p = e.target.closest('.pr-panel'); if (p && window.pappyShowTab) window.pappyShowTab(p.dataset.key);
  });
})();
